//# sourceMappingURL=super_admin.mjs.map
/// <reference types="./super_admin.d.mts" />
import * as $ask from "../../../altar/altar/ask.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $store from "../../data/store.mjs";

export const super_admin_org_header = "x-super-admin-org";

export function apply_org_header(request, store) {
  let $ = store.organization;
  if ($ instanceof Some) {
    let org_id = $[0];
    let _pipe = request;
    return $ask.add_header(_pipe, super_admin_org_header, org_id);
  } else {
    return request;
  }
}
